import script from "./AddonsPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddonsPage.vue?vue&type=script&lang=ts&setup=true"

import "./AddonsPage.vue?vue&type=style&index=0&id=916c8172&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-916c8172"]])

export default __exports__